<template>
  <div class="detail">
    <div class="column-card">
      <van-image :src="info.iconUrl" lazy-load class="column-logo" @click.stop="() => preViewImage(0)"/>
      <div class="title-warp">
        <span :inOrOut="info.inOrOut" class="sd_column_card_name_tag">{{info.inOrOut === 1 ? '内部' : '外部'}}</span>
        <span class="column-title">
          {{info.name}}
        </span>
        <van-button
          v-if="!info.isOwner"
          size="small"
          round
          class="favor-btn"
          @click="updateColumnFavor"
          type="default">
          {{info.isFavor ? '已订阅' : '订阅'}}
        </van-button>
      </div>
      <div class="intro">
        {{info.intro}}
      </div>
      <div class="column-top">
        <div class="column-info-warp">
          <div class="info">
            <span
              v-for="owner in info.ownerListPro"
              :key="owner.userId"
              class="user"
            >
              <div class="avatar">
                <img class="avatar-icon" :src="owner.iconUrl"/>
                <FansPendant v-if="owner.userId" :userId="owner.userId"/>
              </div>
              <span>{{owner.name}}</span>
            </span>
          </div>
          <div class="view-info">
              <span>{{info.viewNum}} 人浏览 · {{info.favorNum}} 人订阅</span>
          </div>
          <!-- <div>
            <van-button
              size="mini"
              round
              class="favor-btn"
              type="default">
              {{info.isFavor ? '已订阅' : '订阅'}}
            </van-button>
            <van-button
              size="mini"
              round
              class="favor-btn"
              type="default">
              分享
            </van-button>
          </div> -->
        </div>
        <van-button
            size="small"
            round
            @click="handleShare"
            type="default">
            <img style="width: 13px;height: 12px" src="../../assets/share.png"/>
          </van-button>
      </div>
      
    </div>
    <van-pull-refresh
      v-if="articleList.length || loading"
      v-model="refreshing"
      @refresh="onRefresh"
      success-text="刷新成功">
      <van-divider :style="{  padding: '0 16px', fontSize: '12px', margin: '8px 0px 0px 0px' }" :hairline="false">专栏文章</van-divider>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <ArticleCard
          v-for="item in articleList"
          :key="item.id"
          @refresh="handleRefresh"
          timeField="createTime"
          :rowData="item"
        />
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import api from '../../api';
import { getDateDiff } from '../../utils/lib';
// import ColumnCard from '../../components/columnCard.vue';
import ArticleCard from '../article/components/card.vue';
import { mapActions, mapState } from 'vuex';
import { ImagePreview } from 'vant';
import FansPendant from '../../components/fansPendant.vue';
export default {
  components: {
    // ColumnCard,
    ArticleCard,
    FansPendant
  },
  data() {
    return {
      info: {},
      getDateDiff,
      pageParams: {
        page: 1,
        pageSize: 10
      },
      articleList: [],
      loading: false,
      finished: false,
      refreshing: false,
    }
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    ...mapState(['userInfo'])
  },
  watch: {
    id: {
      immediate: true,
      handler(id) {
        if (id) {
          this.init();
        }
      }
    }
  },
  created() {
    this.handleBack();
  },
  methods: {
    ...mapActions(['updateUserInfoList']),
    init() {
      this.getColumnInfo();
      this.onRefresh();
    },
    handleBack() {
      const _this = this
      let options = {
        disabled: true,
        callback: function() {
          if (window.history.length > 1) {
            _this.$router.go(-1)
          } else {
            _this.$router.replace({ name: 'articleList' })
          }
        }
      }
      window.jme.browser.setGoBackDisabled(options)
    },
    preViewImage(index) {
      ImagePreview([this.info.iconUrl], index)
    },
    updateColumnFavor() {
      api.updateColumnFavor(this.id).then(({code}) => {
        if (code === 200) {
          this.info = {
            ...this.info,
            isFavor: this.info.isFavor === 1 ? 0 : 1,
            favorNum: this.info.isFavor === 1 ? this.info.favorNum - 1 : this.info.favorNum + 1
          }
        }
      })
    },
    handleShare() {
      const { name, intro, id, } = this.info
      const shareId = this.$route.query.shareId ? this.$route.query.shareId : this.userInfo.id;
      const url = `http://sd.jd.com/column/${id}?shareId=${shareId}&isHideShareButton=1`
      const options = {
        shareData: {
          title: name,
          content: intro,
          url,
          icon: 'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-02-28-17-07uAVeSgG0YYEUaxf.png',
        },
        typeList: ['JDMESession', 'CopyLink'],
        callback: function() {}
      }
      window.jme.share.shareCustom(options)
    },
    getColumnInfo() {
      api.getColumnInfo({
        id: this.id
      }).then((res) => {
        const { code, data } = res;
        if (code === 200) {
          this.info = data;
          const userIds = data?.ownerListPro?.map((item) => item.userId);
          if (userIds?.length) {
            this.updateUserInfoList(userIds.join())
          }
        }
      })
    },
    getColumnPostList() {
      this.loading = true
      api.getColumnPostList({
        ...this.pageParams,
        columnId: this.id
      }).then((res) => {
        const {code, data, totalCount} = res;
        this.loading = false
        if (this.refreshing) {
          this.refreshing = false
        }
        if (code === 200) {
          const userIds = data?.map((item) => item.userId);
          if (userIds?.length) {
            this.updateUserInfoList(userIds.join())
          }
          if (this.pageParams.page > 1) {
            this.articleList = this.articleList.concat(data)
          } else {
            this.articleList = data
          }
          if (this.articleList.length >= totalCount) {
            this.finished = true
          }
        }
      })
    },
    onLoad() {
      this.pageParams.page++
      this.getColumnPostList()
    },
    onRefresh() {
      this.finished = false
      this.pageParams.page = 1 
      this.getColumnPostList()
    },
    handleRefresh(val, type) {
      if (val) {
        if (type === 'share') {
          this.articleList = this.articleList.map(item => {
          if (item.id === val.id) {
            item = Object.assign(item, { sharedNum: val.sharedNum })
          }
          return item
        })
          return;
        }
        let up
        let upNum
        if (val.isUp === '踩') {
          up = val.isUp === '踩' ? -1 : 1
          upNum = val.upNum
        } else {
          up = val.isUp === 1 ? -1 : 1
          upNum = val.isUp === 1 ? val.upNum - 1 : val.upNum + 1 
        }
        this.articleList = this.articleList.map(item => {
          if (item.id === val.id) {
            item = Object.assign(item, { isUp: up, upNum })
          }
          return item
        })
      } else {
        this.getColumnPostList()
      }
    },
  }
}
</script>
<style lang="less" scoped>
.detail {
  // padding-top: 10px;
}
.column-card {
  padding: 10px;
  border-radius: 4px;
  text-align: left;
  background: #F1FAEB;
}
.column-top {
  display: flex;
  align-items: center;
}
.column-logo {
  width: 100%;
  // height: 70px;
  border: 1px solid #f0f0f2;
}
.column-info-warp {
  flex: 1;
  overflow: hidden;
  margin-left: 12px;
}
.sd_column_card_name_tag {
  display: inline-block;
  flex-shrink: 0;
  margin-right: 4px;
  padding: 2px 4px;
  font-weight: normal;
  font-size: 12px;
  line-height: 1;
  border-style: solid;
  border-width: 1px;
  border-radius: 2px;
  margin-top: 4px;
  &[inOrOut='1'] {
    color: #9acd32;
    border-color: #9acd32;
  }
  &[inOrOut='0'] {
    color: #f6af58;
    border-color: #f6af58;
  }
}
.title-warp {
  display: flex;
  align-items: flex-start;
  margin-bottom: 4px;
}
.column-title {
  margin-left: 4px;
  font-size: 16px;
  font-weight: bold;
  // overflow: hidden;
  // text-overflow: ellipsis;
  // white-space: nowrap;
}
.favor-btn {
  padding: 0 8px;
  height: 20px;
  border-radius: 12px;
  flex-shrink: 0;
  margin-top: 2px;
  margin-left: 8px;
}
.info {
  font-size: 13px;
  margin-bottom: 4px;
  // color: #a5a3a3;
  display: flex;
  flex-wrap: wrap;
}
.view-info {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #bbb;
  &-left {
    display: flex;
    align-items: center;
    & > span {
      margin-right: 12px;
    }
  }
}
.intro {
  margin: 10px 0;
  color: #666;

}
.user {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-right: 12px;
  margin-bottom: 4px;
  .avatar-icon {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    margin-right: 4px;
  }
}
.avatar {
  position: relative;
}
</style>